import React from 'react';
import ExperiencePage from '../components/ExperiencePage';

const Athenahealth = () => {
  return (
    <ExperiencePage
      company="Athenahealth"
      role="Engineering Manager"
      period="September 2023 to Present"
      description={[
        "Grew and led a brand new team to build a full-stack web app payment portal for customers' B2B payments",
        "Provided guidance in modernization efforts for delivery milestones and strategy shift to automation from operation improving code maintainability, transparency, scalability via AWS, and submission latency",
        "Improved culture, engagement, and skill across 3 teams and 11 direct reports using continuous feedback",
        "Built a performance calibration framework and level expectations shared across the subdivision Collector"
      ]}
    />
  );
};

export default Athenahealth;
